const transfers = {
  transfer: "Transfert", // translated
  transfers: "Transferts", // translated
  dateAndTime: "Date et l'heure", // translated
  transferFrom: "Transfert à partir de", // translated
  duration: "Durée", // translated
  numOfPersons: "Nombre de personnes", // translated
  baggageAllowance: "Franchise de bagages", // translated
  small: "Petit", // translated
  big: "Grand", // translated
  provider: "Fournisseur", // translated
  vehicle: "Véhicule", // translated
  distance: "Distance", // translated
  price: "Prix", // translated
  inboundJourney: "Voyage entrant", // translated
  outboundJourney: "Voyage aller", // translated
  arrivalTime: "Heure d'arrivée", // translated
  flightDetails: "Les détails du vol", // translated
  inboundPickupDate: "Date de ramassage entrant", // translated
  outboundPickupDate: "Date de ramassage sortant", // translated
  travelInfo: "Informations de voyage", // translated
  flightsInfo: "Informations sur les vols", // translated
  airportYouAreFlyingFrom: "Aéroport d'où vous partez", // translated
  airportYouAreFlyingTo: "Aéroport vers lequel vous volez", // translated
  inboundFlightNumber: "Numéro de vol entrant", // translated
  outboundFlightNumber: "Numéro de vol aller", // translated
  inboundAirlineName: "Nom de la compagnie aérienne entrante", // translated
  outboundAirlineName: "Nom de la compagnie aérienne sortante", // translated
  tripMode: "Mode voyage", // translated
  airportToPoint: "De l'aéroport au point", // translated
  pointToAirport: "Pointer vers l'aéroport", // translated
  roundTrip: "Aller-retour", // translated
  destinationPoint: "Point de destination", // translated
  originPoint: "Point d'origine", // translated
  transferType: "Type de transfert", // translated
  min: "Min.", // translated
  max: "Max.", // translated
  pieces: "Pièces", // translated
  cancelationIs: "l'annulation est", // translated
};

export default transfers;
